// AluguelForm.jsx
import React, { useEffect, useState } from 'react';
import {
  Box, Container, Typography, TextField, Button, Snackbar,
  Alert, Autocomplete, FormControlLabel, Switch, Grid,
  InputAdornment, MenuItem, LinearProgress, Checkbox, Chip,
  Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, Tooltip, Table, TableHead, TableRow, TableCell,
  TableBody, Paper, FormControl, InputLabel, Select
} from '@mui/material';
import { Save, Print, Warning, PersonAdd, Close } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import 'react-quill-new/dist/quill.snow.css';
import * as contratosService from '../../../services/contratosService';

const API_URL = process.env.REACT_APP_API_URL;

// Função auxiliar para criar data no fuso horário de Manaus (UTC-4)
// Evita o problema de datas sendo interpretadas como UTC e mudando de dia
const criarDataManaus = (dataString) => {
  if (!dataString) return null;
  
  // Se for string no formato YYYY-MM-DD, cria a data considerando Manaus
  const [ano, mes, dia] = dataString.split('-').map(Number);
  return new Date(ano, mes - 1, dia, 12, 0, 0); // Meio-dia para evitar problemas de fuso
};

// Função para formatar data no formato YYYY-MM-DD sem problemas de timezone
const formatarDataParaInput = (data) => {
  if (!data) return '';
  
  const d = data instanceof Date ? data : new Date(data);
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  
  return `${ano}-${mes}-${dia}`;
};

const cartaoBandeiras = ['Visa', 'MasterCard', 'Elo', 'Diners', 'American Express', 'Outros'];
const formasPagamento = ['Cartão de Crédito', 'Pix', 'Transferência', 'Dinheiro'];
const tiposPeriodo = ['Diária', 'Semanal', 'Mensal'];

export default function AluguelForm() {
    console.log('Renderizando AluguelForm'); // <-- TOP

  useParams();
  
  const navigate = useNavigate();

  const [clientes, setClientes] = useState([]);
  const [clientesComRestricao, setClientesComRestricao] = useState([]);
  const [veiculosDisponiveis, setVeiculosDisponiveis] = useState([]);
  const [promocoes, setPromocoes] = useState([]);
  const [modalRestricaoOpen, setModalRestricaoOpen] = useState(false);
  const [filtroRestricao, setFiltroRestricao] = useState('');
  const [modalNovoClienteOpen, setModalNovoClienteOpen] = useState(false);
  const [novoClienteForm, setNovoClienteForm] = useState({ nome: '', cpf_cnpj: '', telefone: '', email: '', endereco: '', uf: '' });
  const [salvandoCliente, setSalvandoCliente] = useState(false);
  const [templatesContratos, setTemplatesContratos] = useState([]);
  const [templateHtml, setTemplateHtml] = useState('');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [integracaoEmail, setIntegracaoEmail] = useState({ ativo: false, configurado: false });
  const [enviandoEmailPreview, setEnviandoEmailPreview] = useState(false);
  const [emailPreview, setEmailPreview] = useState('');
  const [integracaoWhatsapp, setIntegracaoWhatsapp] = useState({ conectado: false });
  const [enviandoWhatsappPreview, setEnviandoWhatsappPreview] = useState(false);
  const [whatsappPreview, setWhatsappPreview] = useState('');
  const [dadosEmpresa, setDadosEmpresa] = useState({
    empresa_razao_social: '',
    empresa_cnpj: '',
    empresa_endereco: '',
    empresa_cidade: '',
    empresa_estado: '',
    empresa_telefone: '',
    empresa_email: ''
  });
  const [form, setForm] = useState({
    cliente: null, veiculo: null, promocao: null,
    retirada: '', devolucao: '', data_real_devolucao: '',
    tipo_periodo: 'Diária', quantidade_periodos: 1,
    desconto_manual: 0, forma_pagamento: '', bandeira_cartao: '',
    pago_na_retirada: false, observacoes_pagamento: '',
    status_aluguel: 'Em Andamento',
    template_contrato_id: null,
    enviar_contrato_whatsapp: false,
    enviar_contrato_email: false
  });
  const [resumo, setResumo] = useState({ dias: 0, diaria: 0, bruto: 0, desconto: '', total: 0, atraso: 0, multa: '' });
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '', tipo: 'success' });
  const [errors, setErrors] = useState({});

  // Carrega dados iniciais
  useEffect(() => {
    const token = localStorage.getItem('token');
    async function fetchData() {
      try {
        const [cRes, pRes, tRes, rRes] = await Promise.all([
          axios.get(`${API_URL}/clientes?status_financeiro=Liberado`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/promocoes`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/contratos/templates`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/clientes-com-restricao`, { headers: { Authorization: `Bearer ${token}` } })
        ]);
        const clientesUnicos = Array.from(
          new Map(cRes.data.map(c => [c.id, c])).values()
        );
        setClientes(clientesUnicos);
        setClientesComRestricao(rRes.data || []);
        setPromocoes(pRes.data);
        setTemplatesContratos(tRes.data.filter(t => t.ativo === 1));
        try {
          const config = await contratosService.buscarConfiguracoesContratos();
          setDadosEmpresa({
            empresa_razao_social: config.empresa_razao_social || '',
            empresa_cnpj: config.empresa_cnpj || '',
            empresa_endereco: config.empresa_endereco || '',
            empresa_cidade: config.empresa_cidade || '',
            empresa_estado: config.empresa_estado || '',
            empresa_telefone: config.empresa_telefone || '',
            empresa_email: config.empresa_email || ''
          });
        } catch (errConfig) {
          console.error('Erro ao carregar configuracoes de contratos:', errConfig);
        }
        try {
          const emailRes = await axios.get(`${API_URL}/integracoes/email`, { headers: { Authorization: `Bearer ${token}` } });
          const rawCfg = emailRes.data?.configuracao;
          const cfg = typeof rawCfg === 'string' ? JSON.parse(rawCfg) : (rawCfg || {});
          setIntegracaoEmail({
            ativo: !!emailRes.data?.ativo,
            configurado: !!(cfg.servidor && cfg.usuario && cfg.senha)
          });
        } catch {
          setIntegracaoEmail({ ativo: false, configurado: false });
        }
        try {
          const wpRes = await axios.get(`${API_URL}/whatsapp/status`, { headers: { Authorization: `Bearer ${token}` } });
          setIntegracaoWhatsapp({ conectado: !!wpRes.data?.dados?.conectado });
        } catch {
          setIntegracaoWhatsapp({ conectado: false });
        }
      } catch {
        setSnack({ open: true, msg: 'Erro ao carregar dados', tipo: 'error' });
      }
    }
    fetchData();
  }, []);

  // Busca veículos disponíveis para as datas selecionadas
  const buscarVeiculosDisponiveis = async (data_retirada, data_devolucao) => {
    if (!data_retirada || !data_devolucao) {
      setVeiculosDisponiveis([]);
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/veiculos-disponiveis`, {
        params: { data_retirada, data_devolucao },
        headers: { Authorization: `Bearer ${token}` }
      });
      const disponiveis = response.data?.veiculos || response.data || [];
      setVeiculosDisponiveis(disponiveis);
      if (form.veiculo && !disponiveis.find(v => v.id === form.veiculo.id)) {
        setForm(f => ({ ...f, veiculo: null }));
        setSnack({ open: true, msg: 'Veículo selecionado não está mais disponível para essas datas', tipo: 'warning' });
      }
    } catch (error) {
      setVeiculosDisponiveis([]);
      setSnack({ open: true, msg: `Erro ao buscar veículos: ${error.response?.data?.mensagem || error.message}`, tipo: 'error' });
    }
  };

  // Busca veículos disponíveis quando as datas são atualizadas
  useEffect(() => {
    if (form.retirada && form.devolucao) {
      buscarVeiculosDisponiveis(form.retirada, form.devolucao); // eslint-disable-line react-hooks/set-state-in-effect
    }
  }, [form.retirada, form.devolucao]);

  const calcularResumo = (form) => {
    const diariaBase = form.veiculo?.preco_dia || 0;
    let diaria = diariaBase;
    let dias = Number(form.quantidade_periodos || 0);
    let tipo = form.tipo_periodo;

    if (tipo === 'Semanal' && form.veiculo?.preco_semana) {
      diaria = form.veiculo.preco_semana / 7;
      dias *= 7;
    } else if (tipo === 'Mensal' && form.veiculo?.preco_mes) {
      diaria = form.veiculo.preco_mes / 30;
      dias *= 30;
    }

    const retirada = form.retirada ? criarDataManaus(form.retirada) : null;
    const devolucao = retirada ? new Date(retirada.getTime() + dias * 24 * 60 * 60 * 1000) : null;
    const bruto = diaria * dias;

    const descontoPromo = form.promocao
      ? Math.floor(dias / (form.promocao.dias_pagos + form.promocao.dias_ganhos)) * form.promocao.dias_ganhos * diaria
      : 0;

    const descontoManual = parseFloat(form.desconto_manual || 0);
    const total = bruto - descontoPromo - descontoManual;

    let atraso = 0;
    let multa = 0;
    if (form.data_real_devolucao && devolucao) {
      const real = criarDataManaus(form.data_real_devolucao);
      const delta = Math.ceil((real - devolucao) / (1000 * 60 * 60 * 24));
      if (delta > 0) {
        atraso = delta;
        multa = atraso * diaria;
      }
    }

    return {
      dias,
      diaria,
      bruto,
      desconto: descontoPromo + descontoManual,
      total,
      atraso,
      multa,
      dataPrevista: devolucao ? formatarDataParaInput(devolucao) : ''
    };
  };

const atualizarResumo = (newForm) => {
  const r = calcularResumo(newForm);

  setResumo(prev => {
    const descontoFinal = parseFloat(prev.desconto !== '' ? prev.desconto : r.desconto) || 0;
    const multaFinal = parseFloat(prev.multa !== '' ? prev.multa : r.multa) || 0;

    return {
      dias: r.dias,
      diaria: r.diaria,
      bruto: r.bruto,
      desconto: prev.desconto !== '' ? prev.desconto : r.desconto,
      multa: prev.multa !== '' ? prev.multa : r.multa,
      total: r.bruto - descontoFinal + multaFinal,
      atraso: r.atraso
    };
  });

  setForm(f => ({ ...f, devolucao: r.dataPrevista }));
};

// Busca o HTML do template selecionado
useEffect(() => {
  const id = form.template_contrato_id;
  let mounted = true;

  (async () => {
    if (!id) {
      if (mounted) setTemplateHtml('');
      return;
    }
    try {
      const tpl = await contratosService.buscarTemplate(id);
      if (mounted) setTemplateHtml(tpl.conteudo_html || '');
    } catch (err) {
      console.error('Erro ao buscar template do contrato:', err);
      if (mounted) setTemplateHtml('');
    }
  })();

  return () => { mounted = false; };
}, [form.template_contrato_id]);

// Substitui variáveis no template pelo conteúdo do formulário
const preencherTemplate = (html) => {
  if (!html) return '';

  const values = {
    '{{easy_razao_social}}': dadosEmpresa.empresa_razao_social || 'Delta Rent Car LTDA',
    '{{easy_cnpj}}': dadosEmpresa.empresa_cnpj || '',
    '{{easy_endereco}}': dadosEmpresa.empresa_endereco || '',
    '{{easy_cidade}}': dadosEmpresa.empresa_cidade || 'Manaus',
    '{{easy_estado}}': dadosEmpresa.empresa_estado || 'AM',
    '{{easy_telefone}}': dadosEmpresa.empresa_telefone || '',
    '{{easy_email}}': dadosEmpresa.empresa_email || 'contato@deltarentcar.com.br',

    '{{cliente_nome}}': form.cliente?.nome || '',
    '{{cliente_cpf}}': form.cliente?.cpf_cnpj || '',
    '{{cliente_rg}}': form.cliente?.rg || '',
    '{{cliente_endereco}}': form.cliente?.endereco || '',
    '{{cliente_cidade}}': form.cliente?.cidade || '',
    '{{cliente_telefone}}': form.cliente?.telefone || '',
    '{{cliente_email}}': form.cliente?.email || '',
    '{{cliente_data_nascimento}}': form.cliente?.data_nascimento || '',
    '{{cliente_cnh}}': form.cliente?.cnh || '',

    '{{veiculo_marca}}': form.veiculo?.marca || '',
    '{{veiculo_modelo}}': form.veiculo?.modelo || '',
    '{{veiculo_placa}}': form.veiculo?.placa || '',
    '{{veiculo_ano}}': form.veiculo?.ano || '',
    '{{veiculo_cor}}': form.veiculo?.cor || '',
    '{{veiculo_chassi}}': form.veiculo?.chassi || '',
    '{{veiculo_renavam}}': form.veiculo?.renavam || '',
    '{{veiculo_km_atual}}': form.veiculo?.km_atual || '',

    '{{data_inicio}}': form.retirada ? new Date(form.retirada).toLocaleDateString('pt-BR') : '',
    '{{data_fim}}': form.devolucao ? new Date(form.devolucao).toLocaleDateString('pt-BR') : '',
    '{{data_contrato}}': new Date().toLocaleDateString('pt-BR'),
    '{{dias_locacao}}': resumo.dias || '',
    '{{hora_retirada}}': '',
    '{{hora_devolucao}}': '',

    '{{valor_diaria}}': resumo.diaria ? `R$ ${Number(resumo.diaria).toFixed(2)}` : '',
    '{{valor_total}}': resumo.total ? `R$ ${Number(resumo.total).toFixed(2)}` : '',
    '{{valor_caucao}}': '',
    '{{forma_pagamento}}': form.forma_pagamento || '',
    '{{multas_valor}}': resumo.multa ? `R$ ${Number(resumo.multa).toFixed(2)}` : '',
  };

  let out = html;
  Object.keys(values).forEach(k => {
    const v = values[k] || '';
    out = out.split(k).join(v);
  });
  return out;
};

const enviarEmailPreview = async () => {
  const destinatario = emailPreview || form.cliente?.email || '';
  if (!destinatario) {
    setSnack({ open: true, msg: 'Informe o e-mail do destinatário', tipo: 'warning' });
    return;
  }
  try {
    setEnviandoEmailPreview(true);
    const token = localStorage.getItem('token');
    const html = preencherTemplate(templateHtml);
    await axios.post(`${API_URL}/integracoes/email/enviar-html`, {
      email: destinatario,
      html,
      assunto: `Pré-visualização do Contrato - ${form.veiculo?.modelo || 'Veículo'}`
    }, { headers: { Authorization: `Bearer ${token}` } });
    setSnack({ open: true, msg: `E-mail enviado para ${destinatario}`, tipo: 'success' });
  } catch (erro) {
    const msg = erro.response?.data?.erro || erro.message;
    setSnack({ open: true, msg: `Erro ao enviar: ${msg}`, tipo: 'error' });
  } finally {
    setEnviandoEmailPreview(false);
  }
};

const enviarWhatsappPreview = async () => {
  const numero = whatsappPreview || form.cliente?.telefone || '';
  if (!numero) {
    setSnack({ open: true, msg: 'Informe o número do WhatsApp', tipo: 'warning' });
    return;
  }
  if (!templateHtml) {
    setSnack({ open: true, msg: 'Selecione um template de contrato', tipo: 'warning' });
    return;
  }
  try {
    setEnviandoWhatsappPreview(true);
    const token = localStorage.getItem('token');
    const nomeCliente = form.cliente?.nome || 'Cliente';
    const veiculoNome = form.veiculo ? `${form.veiculo.marca || ''} ${form.veiculo.modelo || ''}`.trim() : 'Veículo';
    const placa = form.veiculo?.placa || '-';
    const dataInicio = form.retirada ? new Date(form.retirada).toLocaleDateString('pt-BR') : '---';
    const dataFim = form.devolucao ? new Date(form.devolucao).toLocaleDateString('pt-BR') : '---';
    const dias = resumo.dias || 0;
    const textoDias = dias === 1 ? '1 diária' : `${dias} diárias`;
    const valorTotal = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resumo.total || 0);

    // Criar contrato temporário no banco para gerar link real de assinatura
    const htmlRendered = preencherTemplate(templateHtml);
    const previewRes = await axios.post(`${API_URL}/contratos/preview-assinatura`,
      { html: htmlRendered },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const tokenContrato = previewRes.data?.token || '';
    const frontendUrl = 'https://locadora.athixdev.xyz';
    const linkAssinatura = tokenContrato
      ? `${frontendUrl}/contratos/assinar/${tokenContrato}`
      : (previewRes.data?.link_assinatura || '');

    const mensagem = `Olá *${nomeCliente}*! 👋

📄 *Seu Contrato de Locação está pronto!*

🚗 *Veículo:* ${veiculoNome}
🔖 *Placa:* ${placa}
📅 *Período:* ${dataInicio} até ${dataFim}
⏱️ *Duração:* ${textoDias}
💰 *Valor Total:* ${valorTotal}

📲 *Acesse e assine seu contrato:*
${linkAssinatura}

⚠️ *Importante:*
• Assine antes da retirada do veículo
• Guarde este link para consultas futuras
• Apresente documento com foto no dia da retirada`;

    await axios.post(`${API_URL}/whatsapp/enviar`, { numero, mensagem }, { headers: { Authorization: `Bearer ${token}` } });
    setSnack({ open: true, msg: `Contrato enviado para ${numero} com link de assinatura`, tipo: 'success' });
  } catch (erro) {
    const msg = erro.response?.data?.erro || erro.message;
    setSnack({ open: true, msg: `Erro ao enviar: ${msg}`, tipo: 'error' });
  } finally {
    setEnviandoWhatsappPreview(false);
  }
};

const imprimirContrato = () => {
  const htmlContrato = preencherTemplate(templateHtml);
  if (!htmlContrato) {
    setSnack({ open: true, msg: 'Nenhum contrato para imprimir', tipo: 'warning' });
    return;
  }

  const nomeEmpresa = dadosEmpresa.empresa_razao_social || 'Delta Rent Car';
  const nomeCliente = form.cliente?.nome || '';
  const placaVeiculo = form.veiculo?.placa || '';

  const printWindow = window.open('', '_blank', 'width=900,height=700');
  printWindow.document.write(`<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Contrato — ${nomeCliente} — ${placaVeiculo}</title>
  <style>
    /* Reset */
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    /* Tela: fundo cinza, folha centralizada */
    body {
      background: #d0d0d0;
      font-family: 'Times New Roman', Times, serif;
      color: #111;
    }

    /* Folha A4 */
    .page {
      width: 210mm;
      min-height: 297mm;
      margin: 20mm auto;
      padding: 20mm 25mm;
      background: #fff;
      box-shadow: 0 4px 24px rgba(0,0,0,0.25);
      position: relative;
    }

    /* Conteúdo do template Quill */
    .ql-snow .ql-editor { padding: 0; }
    .ql-editor p, p { margin-bottom: 10px; line-height: 1.8; font-size: 12pt; }
    .ql-editor h1, h1 { font-size: 18pt; text-align: center; margin-bottom: 14px; }
    .ql-editor h2, h2 { font-size: 15pt; margin-bottom: 10px; }
    .ql-editor h3, h3 { font-size: 13pt; margin-bottom: 8px; }
    .ql-editor ul, ul { padding-left: 20px; margin-bottom: 10px; }
    .ql-editor li, li { line-height: 1.8; font-size: 12pt; }
    .ql-editor table, table { width: 100%; border-collapse: collapse; margin-bottom: 14px; }
    .ql-editor td, .ql-editor th, td, th { border: 1px solid #999; padding: 6px 10px; font-size: 11pt; }
    .ql-editor th, th { background: #f0f0f0; font-weight: bold; }
    strong, b { font-weight: bold; }
    em, i { font-style: italic; }
    u { text-decoration: underline; }

    /* Rodapé com número de página */
    @page {
      size: A4;
      margin: 0;
    }

    /* Impressão: remove o fundo, sem sombra */
    @media print {
      body { background: none; }
      .page {
        margin: 0;
        padding: 18mm 22mm;
        box-shadow: none;
        width: 210mm;
        min-height: 297mm;
      }
      .no-print { display: none !important; }
    }
  </style>
  <link rel="stylesheet" href="https://cdn.quilljs.com/1.3.7/quill.snow.css">
</head>
<body>
  <!-- Barra de ação (só aparece na tela, não na impressão) -->
  <div class="no-print" style="
    position: fixed; top: 0; left: 0; right: 0; z-index: 9999;
    background: #1a1a2e; color: #fff;
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 32px; font-family: Arial, sans-serif; font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  ">
    <span style="font-weight:600; font-size:15px;">
      📄 Contrato — ${nomeCliente}${placaVeiculo ? ' · ' + placaVeiculo : ''}
    </span>
    <div style="display:flex; gap:12px;">
      <button onclick="window.print()" style="
        background:#ED3237; color:#fff; border:none; border-radius:6px;
        padding:8px 22px; font-size:14px; font-weight:bold; cursor:pointer;
        display:flex; align-items:center; gap:6px;
      ">🖨️ Imprimir / Salvar PDF</button>
      <button onclick="window.close()" style="
        background:transparent; color:#ccc; border:1px solid #555; border-radius:6px;
        padding:8px 16px; font-size:14px; cursor:pointer;
      ">✕ Fechar</button>
    </div>
  </div>

  <!-- Espaço para a barra fixa -->
  <div class="no-print" style="height:54px;"></div>

  <!-- Folha do contrato -->
  <div class="page ql-snow">
    <div class="ql-editor">
      ${htmlContrato}
    </div>
  </div>
</body>
</html>`);
  printWindow.document.close();
};

  const handleAuto = (field, value) => {
    const newForm = { ...form, [field]: value };
    setForm(newForm);
    atualizarResumo(newForm);
    if (field === 'cliente' && value?.email) setEmailPreview(value.email);
    if (field === 'cliente' && value?.telefone) setWhatsappPreview(value.telefone);
  };

const handleInput = (e) => {
  const { name, value, type, checked } = e.target;
  const val = type === 'checkbox' ? checked : value;

  setForm({ ...form, [name]: val });

  if (['desconto', 'multa'].includes(name)) {
    setResumo(prev => ({ ...prev, [name]: value }));
  } else {
    atualizarResumo({ ...form, [name]: val });
  }
};


  const validar = () => {
    const err = {};
    ['cliente', 'veiculo', 'retirada', 'forma_pagamento'].forEach(f => {
      if (!form[f]) err[f] = 'Campo obrigatório';
    });
    if (form.forma_pagamento === 'Cartão de Crédito' && !form.bandeira_cartao) {
      err.bandeira_cartao = 'Obrigatório';
    }
    setErrors(err);
    return !Object.keys(err).length;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
    console.log('Tentou enviar form');

  if (!validar()) {
    setSnack({ open: true, msg: 'Erros no formulário', tipo: 'error' });
    return;
  }

  setLoading(true);
  const token = localStorage.getItem('token');
  const dados = {
    id_cliente: form.cliente.id,
    id_veiculo: form.veiculo.id,
    promocao_id: form.promocao?.id || null,
    data_retirada: form.retirada,
    data_devolucao: form.devolucao,
    valor_diaria: resumo.diaria,
    forma_pagamento: form.forma_pagamento,
    bandeira_cartao: form.bandeira_cartao,
    pago_na_retirada: form.pago_na_retirada ? 1 : 0,
    observacoes_pagamento: form.observacoes_pagamento,
    status_aluguel: form.status_aluguel,
    tipo_periodo: form.tipo_periodo,
    quantidade_periodos: form.quantidade_periodos,
    status_pagamento: form.pago_na_retirada ? 'Pago' : 'Pendente',
    // Dados do contrato digital
    template_contrato_id: form.template_contrato_id || null,
    enviar_contrato_whatsapp: form.enviar_contrato_whatsapp,
    enviar_contrato_email: form.enviar_contrato_email,
    // Dados do cliente para envio do contrato
    cliente_nome: form.cliente.nome,
    cliente_email: form.cliente.email,
    cliente_telefone: form.cliente.telefone,
    cliente_cpf: form.cliente.cpf_cnpj,
    // Dados do veículo para o contrato
    veiculo_modelo: form.veiculo.modelo,
    veiculo_placa: form.veiculo.placa,
    veiculo_cor: form.veiculo.cor,
    veiculo_ano: form.veiculo.ano,
  };

  try {
    console.log(`${API_URL}/alugueis`, dados);

    await axios.post(`${API_URL}/alugueis`, dados, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setSnack({ open: true, msg: 'Salvo com sucesso!', tipo: 'success' });
    setTimeout(() => navigate('/alugueis'), 1000);
  } catch (error) {
    let mensagem = 'Erro ao salvar';
    
    if (error.response?.status === 409) {
      const conflito = error.response?.data?.conflito;
      if (conflito) {
        mensagem = `Veículo indisponível: tem aluguel de ${conflito.cliente_nome} de ${conflito.data_retirada} a ${conflito.data_devolucao}`;
      } else {
        mensagem = 'Veículo já tem aluguel para esse período';
      }
    } else if (error.response?.status === 400) {
      mensagem = error.response?.data?.erro || 'Datas inválidas';
    }
    
    setSnack({ open: true, msg: mensagem, tipo: 'error' });
  } finally {
    setLoading(false);
  }
};

// Função para imprimir recibo fiscal
const imprimirRecibo = () => {
  if (!form.cliente || !form.veiculo) {
    setSnack({ open: true, msg: 'Preencha cliente e veículo para imprimir', tipo: 'warning' });
    return;
  }

  const agora = new Date();
  const dataFormatada = agora.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const horaFormatada = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const window_print = window.open('', '', 'width=500,height=600');
  const html = `
    <!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="UTF-8">
      <title>Recibo de Aluguel</title>
      <style>
        * { margin: 0; padding: 0; }
        body { font-family: 'Courier New', monospace; width: 58mm; background: white; color: #000; }
        .receipt { padding: 10mm; text-align: center; }
        .header { border-bottom: 2px dashed #000; padding-bottom: 10px; margin-bottom: 10px; }
        .title { font-size: 18px; font-weight: bold; margin-bottom: 5px; }
        .subtitle { font-size: 12px; color: #666; margin-bottom: 10px; }
        .divider { border-top: 2px dashed #000; margin: 10px 0; }
        .section { text-align: left; margin: 10px 0; }
        .section-title { font-weight: bold; font-size: 11px; border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px; }
        .row { display: flex; justify-content: space-between; font-size: 11px; margin: 3px 0; word-wrap: break-word; }
        .label { font-weight: bold; flex: 0 0 40%; }
        .value { flex: 1; text-align: right; }
        .centered { text-align: center; font-size: 11px; margin: 5px 0; }
        .total-section { font-weight: bold; text-align: right; font-size: 14px; margin: 10px 0; }
        .footer { font-size: 10px; color: #666; margin-top: 15px; border-top: 2px dashed #000; padding-top: 10px; }
        .obrigado { font-size: 12px; font-weight: bold; margin: 10px 0; }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="header">
          <div class="title">🚗 DELTA RENT CAR</div>
          <div class="subtitle">Recibo de Aluguel</div>
          <div class="centered">Pedido: ${Math.floor(Math.random() * 100000)}</div>
        </div>

        <div class="divider"></div>

        <div class="section">
          <div class="section-title">CLIENTE</div>
          <div class="row">
            <div class="label">Nome:</div>
            <div class="value">${form.cliente?.nome || 'N/A'}</div>
          </div>
          <div class="row">
            <div class="label">CPF:</div>
            <div class="value">${form.cliente?.cpf || 'N/A'}</div>
          </div>
          <div class="row">
            <div class="label">Telefone:</div>
            <div class="value">${form.cliente?.telefone || 'N/A'}</div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="section">
          <div class="section-title">VEÍCULO</div>
          <div class="row">
            <div class="label">Modelo:</div>
            <div class="value">${form.veiculo?.modelo || 'N/A'}</div>
          </div>
          <div class="row">
            <div class="label">Placa:</div>
            <div class="value">${form.veiculo?.placa || 'N/A'}</div>
          </div>
          <div class="row">
            <div class="label">Cor:</div>
            <div class="value">${form.veiculo?.cor || 'N/A'}</div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="section">
          <div class="section-title">PERÍODO</div>
          <div class="row">
            <div class="label">Retirada:</div>
            <div class="value">${new Date(form.retirada).toLocaleDateString('pt-BR')}</div>
          </div>
          <div class="row">
            <div class="label">Devolução:</div>
            <div class="value">${new Date(form.devolucao).toLocaleDateString('pt-BR')}</div>
          </div>
          <div class="row">
            <div class="label">Dias:</div>
            <div class="value">${resumo.dias}</div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="section">
          <div class="section-title">VALORES</div>
          <div class="row">
            <div class="label">Diária:</div>
            <div class="value">R$ ${Number(resumo.diaria || 0).toFixed(2)}</div>
          </div>
          <div class="row">
            <div class="label">Bruto (${resumo.dias} dias):</div>
            <div class="value">R$ ${resumo.bruto.toFixed(2)}</div>
          </div>
          ${parseFloat(resumo.desconto) > 0 ? `
          <div class="row">
            <div class="label">Desconto:</div>
            <div class="value">-R$ ${parseFloat(resumo.desconto).toFixed(2)}</div>
          </div>
          ` : ''}
          ${resumo.atraso > 0 ? `
          <div class="row">
            <div class="label">Multa (${resumo.atraso} dias):</div>
            <div class="value">R$ ${parseFloat(resumo.multa || 0).toFixed(2)}</div>
          </div>
          ` : ''}
        </div>

        <div class="divider"></div>

        <div class="total-section">
          TOTAL: R$ ${resumo.total.toFixed(2)}
        </div>

        <div class="section">
          <div class="section-title">PAGAMENTO</div>
          <div class="row">
            <div class="label">Forma:</div>
            <div class="value">${form.forma_pagamento || 'N/A'}</div>
          </div>
          ${form.forma_pagamento === 'Cartão de Crédito' ? `
          <div class="row">
            <div class="label">Bandeira:</div>
            <div class="value">${form.bandeira_cartao || 'N/A'}</div>
          </div>
          ` : ''}
          <div class="row">
            <div class="label">Status:</div>
            <div class="value">${form.pago_na_retirada ? 'PAGO' : 'PENDENTE'}</div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="footer">
          <div class="centered">${dataFormatada}</div>
          <div class="centered">${horaFormatada}</div>
          <div class="obrigado">Obrigado pela confiança!</div>
          <div class="centered">🙏 Volte sempre!</div>
        </div>
      </div>
    </body>
    </html>
  `;

  window_print.document.write(html);
  window_print.document.close();
  setTimeout(() => window_print.print(), 250);
};




  const estadosBrasil = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

  const salvarNovoCliente = async () => {
    if (!novoClienteForm.nome) {
      setSnack({ open: true, msg: 'Nome é obrigatório', tipo: 'error' });
      return;
    }
    setSalvandoCliente(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API_URL}/clientes`, novoClienteForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const res = await axios.get(`${API_URL}/clientes?status_financeiro=Liberado`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientes(Array.from(new Map(res.data.map(c => [c.id, c])).values()));
      setSnack({ open: true, msg: 'Cliente cadastrado com sucesso!', tipo: 'success' });
      setModalNovoClienteOpen(false);
      setNovoClienteForm({ nome: '', cpf_cnpj: '', telefone: '', email: '', endereco: '', uf: '' });
    } catch {
      setSnack({ open: true, msg: 'Erro ao cadastrar cliente', tipo: 'error' });
    } finally {
      setSalvandoCliente(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box component="form" onSubmit={handleSubmit}
        sx={{ display: 'grid', gap: 3 }}>
        
        {/* HEADER */}
        <Box sx={{ bgcolor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#333', p: 3, borderRadius: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
            📋 Novo Aluguel
          </Typography>
          <Typography variant="body2" sx={{ color: '#333' }}>
            Preencha os dados abaixo para criar um novo registro de aluguel
          </Typography>
        </Box>

        {/* SEÇÃO 1: CLIENTE */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            👤 Dados do Cliente
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <Autocomplete
              sx={{ flex: 1 }}
              options={clientes}
              getOptionLabel={c => c.nome ? `${c.nome}${c.cpf_cnpj ? ' — ' + c.cpf_cnpj : ''}` : ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterOptions={(options, { inputValue }) => {
                if (!inputValue) return options;
                const digitosInput = inputValue.replace(/\D/g, '');
                const termoLower = inputValue.toLowerCase();
                return options.filter(c => {
                  const nomeLower = (c.nome || '').toLowerCase();
                  const cpfLimpo = (c.cpf_cnpj || '').replace(/\D/g, '');
                  const telLimpo = (c.telefone || '').replace(/\D/g, '');
                  if (digitosInput.length > 0) {
                    return cpfLimpo.includes(digitosInput) || telLimpo.includes(digitosInput) || nomeLower.includes(termoLower);
                  }
                  return nomeLower.includes(termoLower);
                });
              }}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option.id}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{option.nome}</Typography>
                    {option.cpf_cnpj && (
                      <Typography variant="caption" color="text.secondary">
                        CPF/CNPJ: {option.cpf_cnpj}{option.telefone ? ` — Tel: ${option.telefone}` : ''}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
              value={form.cliente}
              onChange={(e, v) => handleAuto('cliente', v)}
              renderInput={p => (
                <TextField
                  {...p}
                  label="Cliente *"
                  error={!!errors.cliente}
                  helperText={errors.cliente || `${clientes.length} cliente(s) em dia — pesquise por nome, CPF ou telefone`}
                />
              )}
            />
            <Tooltip title={`Clientes com restrição (${clientesComRestricao.length})`}>
              <span>
                <IconButton
                  onClick={() => setModalRestricaoOpen(true)}
                  sx={{
                    mt: 0.5,
                    color: clientesComRestricao.length > 0 ? 'warning.main' : 'text.disabled',
                    bgcolor: clientesComRestricao.length > 0 ? '#fff8e1' : undefined,
                    border: '1px solid',
                    borderColor: clientesComRestricao.length > 0 ? 'warning.main' : 'divider'
                  }}
                >
                  <Warning />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Cadastrar novo cliente">
              <IconButton
                onClick={() => setModalNovoClienteOpen(true)}
                sx={{ mt: 0.5, color: 'primary.main', border: '1px solid', borderColor: 'primary.main' }}
              >
                <PersonAdd />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* SEÇÃO 2: PERÍODO DE ALUGUEL */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            📅 Período de Aluguel
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 2 }}>
            <TextField 
              name="retirada" 
              type="date" 
              label="Data Retirada *" 
              InputLabelProps={{ shrink: true }}
              value={form.retirada} 
              onChange={handleInput} 
              error={!!errors.retirada} 
            />
            <TextField 
              select 
              name="tipo_periodo" 
              label="Tipo de Período"
              value={form.tipo_periodo} 
              onChange={handleInput}>
              {tiposPeriodo.map(tp => <MenuItem key={tp} value={tp}>{tp}</MenuItem>)}
            </TextField>
            <TextField 
              name="quantidade_periodos" 
              label="Quantidade"
              type="number" 
              value={form.quantidade_periodos} 
              onChange={handleInput} 
            />
          </Box>
          <TextField 
            name="devolucao" 
            label="Data Prevista Devolução"
            value={form.devolucao} 
            disabled
            fullWidth
            sx={{ mt: 2 }}
            slotProps={{ input: { sx: { bgcolor: '#e9ecef' } } }}
          />
        </Box>

        {/* SEÇÃO 3: SELEÇÃO DE VEÍCULO */}
        <Box sx={{ bgcolor: form.retirada && form.devolucao ? '#fff3cd' : '#f8f9fa', p: 3, borderRadius: 2, border: form.retirada && form.devolucao && veiculosDisponiveis.length === 0 ? '2px solid #dc3545' : '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            🚗 Seleção de Veículo
          </Typography>
          
          {!form.retirada || !form.devolucao ? (
            <Box sx={{ p: 2, bgcolor: '#f0f0f0', borderRadius: 1, textAlign: 'center', color: '#666' }}>
              <Typography variant="body2">
                ⏳ Selecione as datas de retirada e devolução para ver veículos disponíveis
              </Typography>
            </Box>
          ) : veiculosDisponiveis.length === 0 ? (
            <Box sx={{ p: 2, bgcolor: '#f8d7da', borderRadius: 1, border: '1px solid #f5c6cb', textAlign: 'center', color: '#721c24' }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                ❌ Nenhum veículo disponível para esse período
              </Typography>
              <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
                Tente alterar as datas ou escolher um período diferente
              </Typography>
            </Box>
          ) : (
            <Autocomplete 
              options={veiculosDisponiveis}
              getOptionLabel={v => `${v.modelo} - ${v.placa} - ${v.proprietario}`}
              value={form.veiculo} 
              onChange={(e, v) => handleAuto('veiculo', v)}
              renderInput={p => (
                <TextField 
                  {...p} 
                  label={`Veículo (${veiculosDisponiveis.length} disponível${veiculosDisponiveis.length !== 1 ? 's' : ''}) *`}
                  error={!!errors.veiculo}
                />
              )} 
            />
          )}
        </Box>

        {/* SEÇÃO 4: PROMOÇÃO (opcional) */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            🎁 Promoção (Opcional)
          </Typography>
          <Autocomplete 
            options={promocoes} 
            getOptionLabel={p => p.nome}
            value={form.promocao} 
            onChange={(e, v) => handleAuto('promocao', v)}
            renderInput={p => <TextField {...p} label="Promoção" />} 
          />
        </Box>

        {/* SEÇÃO 5: RESUMO FINANCEIRO */}
        <Box sx={{ bgcolor: '#e7f3ff', p: 3, borderRadius: 2, border: '2px solid #667eea' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            💰 Resumo Financeiro
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: '1fr 1fr 1fr 1fr' }, gap: 2 }}>
            <TextField 
              label="Dias" 
              value={resumo.dias} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField 
              label="Diária (R$)" 
              value={Number(resumo.diaria || 0).toFixed(2)} 
              disabled
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment>, readOnly: true }}
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField 
              label="Valor Bruto (R$)" 
              value={resumo.bruto.toFixed(2)} 
              disabled
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment>, readOnly: true }}
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField
              label="Desconto (R$)"
              name="desconto"
              value={resumo.desconto}
              onChange={handleInput}
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: '1fr 1fr 1fr 1fr' }, gap: 2, mt: 2 }}>
            <TextField 
              label="Dias em Atraso" 
              value={resumo.atraso} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField
              label="Multa (R$)"
              name="multa"
              value={resumo.multa}
              onChange={handleInput}
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
            <TextField 
              label="Data Real Devolução"
              name="data_real_devolucao" 
              type="date" 
              InputLabelProps={{ shrink: true }} 
              value={form.data_real_devolucao} 
              onChange={handleInput} 
            />
          </Box>
          <Box sx={{ mt: 2, p: 2, bgcolor: 'white', borderRadius: 1, border: '2px solid #667eea' }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#667eea' }}>
              Total a Pagar: R$ {resumo.total.toFixed(2)}
            </Typography>
          </Box>
        </Box>

        {/* SEÇÃO 6: CONTRATOS DIGITAIS (EM TESTE) */}
        <Box sx={{ bgcolor: '#fff8e1', p: 3, borderRadius: 2, border: '2px dashed #ffa726' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mr: 2 }}>
              📝 Contrato Digital
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
            Selecione um template de contrato para enviar ao cliente por e-mail ou WhatsApp.
          </Typography>
          
          <Autocomplete 
            options={templatesContratos}
            getOptionLabel={t => t.nome}
            value={templatesContratos.find(t => t.id === form.template_contrato_id) || null}
            onChange={(e, v) => setForm({ ...form, template_contrato_id: v?.id || null })}
            renderInput={p => <TextField {...p} label="Template de Contrato (Opcional)" />}
          />
          
          {form.template_contrato_id && (
            <Box sx={{ mt: 2, p: 2, bgcolor: 'white', borderRadius: 1, border: '1px solid #e0e0e0' }}>
              {/* Dados do cliente para envio */}
              {form.cliente && (
                <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                    📋 Dados para envio do contrato:
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="caption" color="textSecondary">
                        Cliente: <strong>{form.cliente.nome}</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="caption" color="textSecondary">
                        📧 Email: <strong>{form.cliente.email || 'Não informado'}</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="caption" color="textSecondary">
                        📱 WhatsApp: <strong>{form.cliente.telefone || 'Não informado'}</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                  {(!form.cliente.email && form.enviar_contrato_email) && (
                    <Alert severity="warning" sx={{ mt: 1 }}>
                      Cliente sem email cadastrado! Não será possível enviar por email.
                    </Alert>
                  )}
                  {(!form.cliente.telefone && form.enviar_contrato_whatsapp) && (
                    <Alert severity="warning" sx={{ mt: 1 }}>
                      Cliente sem telefone cadastrado! Não será possível enviar por WhatsApp.
                    </Alert>
                  )}
                </Box>
              )}
              
              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                Enviar contrato via:
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={form.enviar_contrato_whatsapp}
                        onChange={(e) => setForm({ ...form, enviar_contrato_whatsapp: e.target.checked })}
                        color="success"
                        disabled={!integracaoWhatsapp.conectado}
                      />
                    }
                    label="WhatsApp"
                    sx={{ mb: 0 }}
                  />
                  {integracaoWhatsapp.conectado ? (
                    <Chip label="Conectado" size="small" sx={{ bgcolor: '#d4edda', color: '#155724', fontSize: 10, height: 18 }} />
                  ) : (
                    <Chip
                      label="Conecte em Integrações"
                      size="small"
                      sx={{ bgcolor: '#f8d7da', color: '#721c24', fontSize: 10, height: 18, cursor: 'pointer' }}
                      onClick={() => window.open('/integracoes', '_blank')}
                    />
                  )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={form.enviar_contrato_email}
                        onChange={(e) => setForm({ ...form, enviar_contrato_email: e.target.checked })}
                        color="primary"
                        disabled={!integracaoEmail.ativo || !integracaoEmail.configurado}
                      />
                    }
                    label="E-mail"
                    sx={{ mb: 0 }}
                  />
                  {integracaoEmail.ativo && integracaoEmail.configurado ? (
                    <Chip label="Configurado" size="small" sx={{ bgcolor: '#d4edda', color: '#155724', fontSize: 10, height: 18 }} />
                  ) : (
                    <Chip
                      label="Configure em Integrações"
                      size="small"
                      sx={{ bgcolor: '#f8d7da', color: '#721c24', fontSize: 10, height: 18, cursor: 'pointer' }}
                      onClick={() => window.open('/integracoes', '_blank')}
                    />
                  )}
                </Box>
              </Box>
              <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#666' }}>
                O contrato é gerado ao salvar e enviado automaticamente pelos meios selecionados.
              </Typography>
            </Box>
          )}
          {form.template_contrato_id && templateHtml && (
            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" onClick={() => setPreviewOpen(true)}>
                Pré-visualizar Contrato
              </Button>
            </Box>
          )}
        </Box>

        {/* SEÇÃO 7: PAGAMENTO */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            💳 Forma de Pagamento
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
            <TextField 
              select 
              label="Forma de Pagamento *" 
              name="forma_pagamento"
              value={form.forma_pagamento} 
              onChange={handleInput} 
              error={!!errors.forma_pagamento}
            >
              {formasPagamento.map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
            </TextField>

            {form.forma_pagamento === 'Cartão de Crédito' && (
              <TextField 
                select 
                label="Bandeira *" 
                name="bandeira_cartao"
                value={form.bandeira_cartao} 
                onChange={handleInput} 
                error={!!errors.bandeira_cartao}
              >
                {cartaoBandeiras.map(b => <MenuItem key={b} value={b}>{b}</MenuItem>)}
              </TextField>
            )}
          </Box>
          <FormControlLabel 
            control={
              <Switch 
                name="pago_na_retirada" 
                checked={form.pago_na_retirada} 
                onChange={handleInput} 
              />
            } 
            label="Pago na Retirada" 
            sx={{ mt: 2 }}
          />
          <TextField 
            label="Observações" 
            name="observacoes_pagamento"
            value={form.observacoes_pagamento} 
            onChange={handleInput}
            multiline 
            rows={2}
            fullWidth
            sx={{ mt: 2 }}
          />
        </Box>

        {/* LOADING */}
        {loading && <LinearProgress sx={{ borderRadius: 1 }} />}

        {/* BOTÕES */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>
          <Button
            variant="text"
            onClick={() => navigate('/alugueis')}
            color="inherit"
          >
            Cancelar
          </Button>
          <Button
            variant="outlined"
            startIcon={<Print />}
            onClick={imprimirRecibo}
            color="secondary"
          >
            Imprimir Recibo
          </Button>
          <Button
            variant="contained"
            startIcon={<Save />}
            type="submit"
            disabled={loading}
            color="primary"
            sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
          >
            Salvar Aluguel
          </Button>
        </Box>
      </Box>

      <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack(s => ({ ...s, open: false }))}>
        <Alert severity={snack.tipo}>{snack.msg}</Alert>
      </Snackbar>

      {/* Modal: Clientes com Restrição */}
      <Dialog open={modalRestricaoOpen} onClose={() => setModalRestricaoOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#ed3237', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Warning />
            Clientes com Restrição ({clientesComRestricao.length})
          </Box>
          <IconButton onClick={() => setModalRestricaoOpen(false)} sx={{ color: '#fff' }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Estes clientes não aparecem na seleção por possuírem pendências financeiras.
          </Typography>
          <TextField
            fullWidth size="small"
            placeholder="Filtrar por nome ou CPF..."
            value={filtroRestricao}
            onChange={e => setFiltroRestricao(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Paper variant="outlined" sx={{ maxHeight: 400, overflow: 'auto' }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow sx={{ '& th': { bgcolor: '#f5f5f5', fontWeight: 700 } }}>
                  <TableCell>Cliente</TableCell>
                  <TableCell>CPF/CNPJ</TableCell>
                  <TableCell>Telefone</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Motivo(s)</TableCell>
                  <TableCell align="right">Pendências</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clientesComRestricao
                  .filter(c => {
                    const f = filtroRestricao.toLowerCase();
                    return !f || (c.nome || '').toLowerCase().includes(f) || (c.cpf_cnpj || '').includes(f);
                  })
                  .map(c => (
                    <TableRow key={c.id} hover>
                      <TableCell sx={{ fontWeight: 600 }}>{c.nome}</TableCell>
                      <TableCell>{c.cpf_cnpj || '-'}</TableCell>
                      <TableCell>{c.telefone || '-'}</TableCell>
                      <TableCell>
                        <Chip label={c.status_financeiro} size="small" color={c.status_financeiro === 'Bloqueado' ? 'error' : 'warning'} />
                      </TableCell>
                      <TableCell>{c.motivos || '-'}</TableCell>
                      <TableCell align="right">{c.total_pendencias || 0}</TableCell>
                    </TableRow>
                  ))}
                {clientesComRestricao.filter(c => {
                  const f = filtroRestricao.toLowerCase();
                  return !f || (c.nome || '').toLowerCase().includes(f) || (c.cpf_cnpj || '').includes(f);
                }).length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ color: 'text.secondary', py: 3 }}>
                      Nenhum cliente encontrado.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalRestricaoOpen(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      {/* Modal: Cadastrar Novo Cliente */}
      <Dialog open={modalNovoClienteOpen} onClose={() => setModalNovoClienteOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: '#3e4095', color: '#ed3237', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PersonAdd />
            Novo Cliente
          </Box>
          <IconButton onClick={() => setModalNovoClienteOpen(false)} sx={{ color: '#ed3237' }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 1 }}>
            <TextField
              label="Nome *"
              value={novoClienteForm.nome}
              onChange={e => setNovoClienteForm(f => ({ ...f, nome: e.target.value.toUpperCase() }))}
              fullWidth sx={{ gridColumn: '1 / -1' }}
            />
            <TextField
              label="CPF / CNPJ"
              value={novoClienteForm.cpf_cnpj}
              onChange={e => setNovoClienteForm(f => ({ ...f, cpf_cnpj: e.target.value }))}
              fullWidth
            />
            <TextField
              label="Telefone"
              value={novoClienteForm.telefone}
              onChange={e => setNovoClienteForm(f => ({ ...f, telefone: e.target.value }))}
              fullWidth
            />
            <TextField
              label="E-mail"
              value={novoClienteForm.email}
              onChange={e => setNovoClienteForm(f => ({ ...f, email: e.target.value.toUpperCase() }))}
              fullWidth sx={{ gridColumn: '1 / -1' }}
            />
            <TextField
              label="Endereço"
              value={novoClienteForm.endereco}
              onChange={e => setNovoClienteForm(f => ({ ...f, endereco: e.target.value.toUpperCase() }))}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>UF</InputLabel>
              <Select value={novoClienteForm.uf} label="UF" onChange={e => setNovoClienteForm(f => ({ ...f, uf: e.target.value }))}>
                {estadosBrasil.map(uf => <MenuItem key={uf} value={uf}>{uf}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setModalNovoClienteOpen(false)} color="inherit">Cancelar</Button>
          <Button onClick={salvarNovoCliente} variant="contained" disabled={salvandoCliente}
            sx={{ bgcolor: '#ed3237', '&:hover': { bgcolor: '#e67e00' } }}>
            {salvandoCliente ? 'Salvando...' : 'Cadastrar Cliente'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { height: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column' } }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1.5, borderBottom: '1px solid #e0e0e0', flexShrink: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span style={{ fontSize: 20 }}>📄</span>
            <span style={{ fontWeight: 700, fontSize: 18 }}>Pré-visualização do Contrato</span>
          </Box>
          <Button size="small" onClick={() => setPreviewOpen(false)} sx={{ minWidth: 0, p: 0.5 }}>✕</Button>
        </DialogTitle>
        <DialogContent sx={{ p: 0, bgcolor: '#e8e8e8', flex: 1, overflowY: 'auto' }}>
          <Box sx={{ maxWidth: 860, mx: 'auto', my: 4, bgcolor: '#fff', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: 1, overflow: 'hidden' }}>
            <div
              className="ql-snow"
              style={{ padding: 0 }}
            >
              <div
                className="ql-editor"
                style={{
                  padding: '48px 64px',
                  fontSize: '14px',
                  lineHeight: 1.8,
                  color: '#111',
                  minHeight: 'unset',
                  overflowY: 'unset',
                }}
                dangerouslySetInnerHTML={{ __html: preencherTemplate(templateHtml) || '<p style="color:#aaa;text-align:center;padding:60px 0;font-family:sans-serif">Nenhum template selecionado</p>' }}
              />
            </div>
          </Box>
        </DialogContent>
        <DialogActions sx={{ borderTop: '1px solid #e0e0e0', px: 3, py: 1.5, flexShrink: 0, flexWrap: 'wrap', gap: 1 }}>
          <Button onClick={() => setPreviewOpen(false)} variant="outlined">Fechar</Button>
          <Button variant="contained" color="inherit" onClick={() => imprimirContrato()}>Imprimir</Button>
          {integracaoEmail.ativo && integracaoEmail.configurado && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
              <TextField
                size="small"
                label="Enviar para e-mail"
                value={emailPreview}
                onChange={(e) => setEmailPreview(e.target.value)}
                placeholder={form.cliente?.email || 'email@exemplo.com'}
                sx={{ width: 230 }}
              />
              <Button
                variant="contained"
                color="primary"
                disabled={enviandoEmailPreview || !emailPreview}
                onClick={enviarEmailPreview}
              >
                {enviandoEmailPreview ? 'Enviando...' : 'Enviar E-mail'}
              </Button>
            </Box>
          )}
          {integracaoWhatsapp.conectado && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: { xs: 1, sm: 0 } }}>
              <TextField
                size="small"
                label="WhatsApp (com link de assinatura)"
                value={whatsappPreview}
                onChange={(e) => setWhatsappPreview(e.target.value)}
                placeholder={form.cliente?.telefone || '92999999999'}
                sx={{ width: 240 }}
              />
              <Button
                variant="contained"
                color="success"
                disabled={enviandoWhatsappPreview || !whatsappPreview}
                onClick={enviarWhatsappPreview}
              >
                {enviandoWhatsappPreview ? 'Enviando...' : '📱 Enviar Contrato'}
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>
    </Container>
  );
}
